import MaterialExTable from "../../../components/tables/MaterialExTable";
import { useHistory } from "react-router-dom";
import { permissionsSelector } from "../../Login/selectors/permissionSelector";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import {
  mainSelectedTab,
  notifTabIndex,
} from "../../CarrierAgreementMgmt/atoms";
import { recordIdToShowInTS } from "../../CarrierAgreementMgmt/OfficeHierarchy/atoms/atoms";
import { useEffect, useState } from "react";
import { getAllNotifications } from "../../../actions/Utilities/Notification";
import { accountAtom } from "../../Login/atoms/AccountAtom";
import ModuleTabs, {
  UtilitiesTabNotif,
} from "../../Dashboard/RecentActivities/ModuleTabs";
import { NavBarItems } from "../NavBarItems";
import { isFromRediInvoice } from "../../CarrierAgreementMgmt/VendorInvoice/InvoiceCapture/atoms/atoms";

const NotificationsTable = ({ notificationsData }) => {
  const history = useHistory();
  const userPermissions = useRecoilValue(permissionsSelector);
  const setRecordToShow = useSetRecoilState(recordIdToShowInTS);
  const [, setSelectedIndex] = useRecoilState(notifTabIndex);
  const [, setTabsIndex] = useRecoilState(mainSelectedTab);
  const [, setNotifTableData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const userAccount = useRecoilValue(accountAtom);
  const [, setIsFromRedirection] = useRecoilState(isFromRediInvoice);

  useEffect(() => {
    if (notificationsData.data?.length > 0) {
      setNotifTableData(notificationsData);
    }
  }, [notificationsData.data]);

  const notifData = async (query) => {
    try {
      const resp = await getAllNotifications(
        userAccount?.emailAddress,
        userAccount?.isFranchise,
        query
      );
      if (resp == undefined) {
        setIsLoading(false);
        return {
          ...query,
          data: [],
          page: 0,
          pageSize: 0,
          totalCount: 0,
        };
      }
      const headers = resp.headers
        ? JSON.parse(JSON.stringify(resp.headers))
        : {};
      // Parse x-pagination header only if it exists
      const pageHeaders = headers["x-pagination"]
        ? JSON.parse(headers["x-pagination"])
        : {};
      setIsLoading(false);
      return {
        ...query,
        data: resp.data || [],
        page: pageHeaders.CurrentPage ? pageHeaders.CurrentPage - 1 : 0,
        pageSize: pageHeaders.PageSize ? pageHeaders.PageSize : 0,
        totalCount: pageHeaders.TotalCount || 0,
      };
    } catch (error) {
      setIsLoading(false);
      return {
        ...query,
        data: [],
        page: 0,
        pageSize: 0,
        totalCount: 0,
      };
    }
  };
  const columns = [
    {
      title: "Message",

      render: (row) => {
        const urlPath = {
          pathname: row.route,
          state: {
            pathname: row.route,
            recordId: row.recordId,
            moduleName: row.moduleName,
            subModuleName: row.subModuleName,
          },
        };
        const isDeactivateDA =
          row.moduleName?.toLowerCase() === "digital assets" &&
          row.message?.toLowerCase().includes("deactivated");

        return (
          <div
            key={row.id}
            onClick={() => {
              if (isDeactivateDA) return;
              const moduleTabs = ModuleTabs(row.route);
              const utilitiesNotifTab = UtilitiesTabNotif(row.route);
              let userTabs = [];
              [...moduleTabs].forEach((tabs) => {
                let temp = [...userPermissions].filter(
                  (user) => user === tabs.permission
                );
                if (temp.length > 0)
                  userTabs.push({
                    to: tabs.to,
                  });
              });
              const navBarIndex = NavBarItems.findIndex((x) =>
                x.path?.toLowerCase()?.includes(row.route?.toLowerCase())
              );
              if (row.route?.toLowerCase().includes("utilitiestab")) {
                const utilitiesTabIndex = utilitiesNotifTab.findIndex((x) =>
                  x.to?.toLowerCase()?.includes(row.route?.toLowerCase())
                );
                setTabsIndex(navBarIndex);
                setSelectedIndex(utilitiesTabIndex);
              }
              setSelectedIndex(navBarIndex);
              history.push(urlPath);
              if (row.moduleName === "Vendor") {
                window.location.reload();
              }
              if (row.moduleName === "Office Hierarchy") {
                setRecordToShow(row.recordId);
              }
              if (row.moduleName === "Vendor Invoice") {
                setIsFromRedirection(true);
              }
            }}
            className={`cursor-pointer text-quinary font-medium font-sans text-sm normal-case ${
              isDeactivateDA ? "pointer-events-none opacity-50" : ""
            }`}
          >
            {row.message} on {row.moduleName}{" "}
            {row.subModuleName.split("_").join(" ")}
          </div>
        );
      },
      customFilterAndSearch: (term, rowData) =>
        rowData.message.toLowerCase().indexOf(term.toLowerCase()) !== -1,
      width: "34%",
    },
    { title: "Created By", field: "createdBy", width: "33%" },
    {
      title: "Created Date",
      field: "createdOn",
      render: (rowData) => {
        const formatDate = (dateString) => {
          if (dateString) {
            const date = new Date(dateString);
            const options = {
              weekday: "long",
              day: "numeric",
              month: "long",
              year: "numeric",
            };
            return date.toLocaleDateString("en-US", options);
          }
          return "";
        };
        return <div className="w-full">{formatDate(rowData.createdOn)}</div>;
      },

      width: "33%",
    },
  ];

  return (
    <main className="w-full overflow-y-auto box-shadow">
      <MaterialExTable
        data={notifData}
        toolbar={true}
        showTitle={false}
        search={true}
        options={{
          toolbar: false,
          showTitle: false,
        }}
        columns={columns}
        isLoading={isLoading}
        searchFieldAlignment="left"
      />
    </main>
  );
};

export default NotificationsTable;
